export const GITHUB_HANDLE: string = '@kieranroneill';
export const TWITTER_HANDLE: string = '@kieranroneill';
export const TWITTER_ID: number = 225894532;
